import React from 'react'

import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

const Loading = () => {
  return (
    <Backdrop open={true} sx={{ color: '#fff', zIndex: 50000 }}>
      <CircularProgress color='inherit' />
    </Backdrop>
  )
}

export default Loading
